/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { usePageContentId } from '@confluence/page-context';

import type {
	useContentStatusContentStatusQuery as useContentStatusContentStatusQuery$data,
	useContentStatusContentStatusQueryVariables as useContentStatusContentStatusQuery$variables,
} from './__types__/useContentStatusContentStatusQuery';

const useContentStatusContentStatusQuery = gql`
	query useContentStatusContentStatusQuery($contentId: ID!) {
		content(id: $contentId, status: ["current", "draft", "archived"]) {
			nodes {
				id
				status
				type
			}
		}
	}
`;
type UseContentStatusProps = {
	skip?: boolean;
};

export const useContentStatus = ({ skip = false }: UseContentStatusProps = {}) => {
	const [contentId] = usePageContentId();
	const { loading, error, data, refetch } = useQuery<
		useContentStatusContentStatusQuery$data,
		useContentStatusContentStatusQuery$variables
	>(useContentStatusContentStatusQuery, {
		skip: skip || !contentId,
		variables: {
			contentId: contentId ?? '',
		},
	});
	const contentNode = data?.content?.nodes?.[0];

	return {
		contentStatus: contentNode?.status,
		loading,
		error,
		refetch,
		type: contentNode?.type,
	};
};
